// extracted by mini-css-extract-plugin
module.exports = {"card":"ProfileCard_card__H5A4_","cardNumber":"ProfileCard_cardNumber__MIDH7","cardNumberWrapper":"ProfileCard_cardNumberWrapper__Ob5BN"};